import { AreaChart, Area, XAxis, YAxis, ResponsiveContainer } from "recharts";

const Chart = ({ data, dataKey, max }) => {
  // console.log(max)
  return (
    <ResponsiveContainer width="100%" height={120}>
      <AreaChart
        width={230}
        height={120}
        data={data}
        margin={{
          top: 15,
          right: 10,
          left: 10,
          bottom: 5,
        }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#000" stopOpacity={1} />
            <stop offset="95%" stopColor="#FE0005" stopOpacity={0.5} />
          </linearGradient>
        </defs>
        <YAxis domain={[0, max]} hide={true} />
        <XAxis dataKey="year" tickLine={false} ticks={false} axisLine={false} />
        <Area
          isAnimationActive={false}
          label={{ fill: "red", fontSize: 10, position: "top" }}
          dataKey={dataKey}
          stroke="#FE0005"
          fill="url(#colorUv)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default Chart;
